import { CChartLine } from '@coreui/react-chartjs'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CFormLabel,
  CFormSelect,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import Loader from 'src/components/Loader'
import CommonService from 'src/service/CommonService'
import PlayerService from 'src/service/PlayerService'

const PlayerChart = () => {
  const [labelNames, setLabelNames] = useState([])
  const [playerList, setPlayerList] = useState([])
  const [priceChange, setPriceChange] = useState([])
  const [data, setData] = useState([])

  const [rsData, setRsData] = useState([])
  const [onesData, setOnesData] = useState([])
  const [twosData, setTwosData] = useState([])
  const [threesData, setThreesData] = useState([])
  const [fivesData, setFivesData] = useState([])
  const [sevensData, setSevensData] = useState([])
  const [eightsData, setEightsData] = useState([])
  const [ninesData, setNinesData] = useState([])
  const [outsData, setOutsData] = useState([])
  const [foursData, setFoursData] = useState([])
  const [sixesData, setSixesData] = useState([])
  const [mdnsData, setMdnsData] = useState([])
  const [wksData, setWksData] = useState([])
  const [gameType, setGameType] = useState('')

  const [loading, setLoading] = useState(true)
  useEffect(() => {
    PlayerService.getAllPlayer().then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setPlayerList(res.data)
        setLoading(false)
      }
    })
    CommonService.getGameType().then((res) => {
      if (res.status === 200) {
        setGameType(res.data)
      }
    })
  }, [])

  const handleSearchPlayer = (e) => {
    PlayerService.playerChart(e.target.value).then((res) => {
      setLoading(true)
      if (res.status === 200) {
        setData(res.data.datasets)
        setLabelNames(res.data.labels)
        setPriceChange(res.data.priceChange)
        setRsData(res.data.runsData)

        setOnesData(res.data.onesData)
        setTwosData(res.data.twosData)
        setThreesData(res.data.threesData)
        setFivesData(res.data.fivesData)
        setSevensData(res.data.sevensData)
        setEightsData(res.data.eightsData)
        setNinesData(res.data.ninesData)
        setOutsData(res.data.outsData)

        setFoursData(res.data.foursData)
        setSixesData(res.data.sixesData)
        setMdnsData(res.data.mdnsData)
        setWksData(res.data.wksData)
        setLoading(false)
      }
    })
  }

  const labelNamesa = Object.keys(labelNames)
  const dataValues = Object.values(data).map((value) => parseFloat(value, 10))
  const dataPriceChangeValues = Object.values(priceChange).map((value) => parseFloat(value, 10))

  const dataRunsValues = Object.values(rsData).map((value) => parseFloat(value, 10))
  const dataFoursValues = Object.values(foursData).map((value) => parseFloat(value, 10))

  const dataOnesValues = Object.values(onesData).map((value) => parseFloat(value, 10))
  const dataTwosValues = Object.values(twosData).map((value) => parseFloat(value, 10))
  const dataThreesValues = Object.values(threesData).map((value) => parseFloat(value, 10))
  const dataFivesValues = Object.values(fivesData).map((value) => parseFloat(value, 10))
  const dataSevensValues = Object.values(sevensData).map((value) => parseFloat(value, 10))
  const dataEightsValues = Object.values(eightsData).map((value) => parseFloat(value, 10))
  const dataNinesValues = Object.values(ninesData).map((value) => parseFloat(value, 10))
  const dataOutsValues = Object.values(outsData).map((value) => parseFloat(value, 10))
  const dataSixesValues = Object.values(sixesData).map((value) => parseFloat(value, 10))
  const dataMdnsValues = Object.values(mdnsData).map((value) => parseFloat(value, 10))
  const dataWksValues = Object.values(wksData).map((value) => parseFloat(value, 10))

  const formattedData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Points',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataValues,
      },
    ],
  }
  const formattedPriceChangeData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fantasy Value',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataPriceChangeValues,
      },
    ],
  }

  const formattedRunseData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Runs',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataRunsValues,
      },
    ],
  }

  const formattedFoursData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fours',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataFoursValues,
      },
    ],
  }
  const formattedOnesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Ones',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataOnesValues,
      },
    ],
  }
  const formattedTwosData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Twos',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataTwosValues,
      },
    ],
  }
  const formattedThreesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Threes',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataThreesValues,
      },
    ],
  }
  const formattedFivesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fives',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataFivesValues,
      },
    ],
  }
  const formattedSevensData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Sevens',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataSevensValues,
      },
    ],
  }
  const formattedEightsData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Eights',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataEightsValues,
      },
    ],
  }
  const formattedNinesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Nines',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataNinesValues,
      },
    ],
  }

  const formattedOutsData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Fours',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataFoursValues,
      },
    ],
  }

  const formattedSixesData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Sixes',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataSixesValues,
      },
    ],
  }

  const formattedMdnsData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Maidens',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataMdnsValues,
      },
    ],
  }

  const formattedWksData = {
    labels: labelNamesa,
    datasets: [
      {
        label: 'Wickets',
        backgroundColor: '#36A2EB',
        borderColor: '#36A2EB',
        pointBackgroundColor: '#36A2EB',
        pointBorderColor: '#36A2EB',
        data: dataWksValues,
      },
    ],
  }

  return loading ? (
    <Loader />
  ) : (
    <>
      <CRow>
        <CCol xs={12} sm={12} lg={12}>
          <CCard className="mb-4">
            <CCardHeader>Select Player</CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md={6}>
                  <CFormSelect
                    aria-label="Select player"
                    name="player"
                    className={'form-control'}
                    onChange={handleSearchPlayer}
                    id="player"
                  >
                    <option value={0}>Select Player</option>
                    {playerList &&
                      playerList.map((item, key) => (
                        <option value={item?.id} key={key}>
                          {item?.full_name}
                        </option>
                      ))}
                  </CFormSelect>
                </CCol>
                <CCol md={6}>&nbsp;</CCol>
              </CRow>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
      <CRow>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Points</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Fantasy Value</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedPriceChangeData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Runs</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedRunseData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        {gameType && gameType === 3 && (
          <>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Ones</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedOnesData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Twos</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedTwosData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Threes</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedThreesData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Fours</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedFoursData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Fives</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedFivesData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>

            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Sixes</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedSixesData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Sevens</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedSevensData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Eights</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedEightsData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Nines</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedNinesData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
            <CCol md={6} sm={12}>
              <CCard className="mb-4">
                <CCardHeader>By Outs</CCardHeader>
                <CCardBody>
                  <CCardBody>
                    <CChartLine data={formattedOutsData} />
                  </CCardBody>
                </CCardBody>
              </CCard>
            </CCol>
          </>
        )}

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Maidens</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedMdnsData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>

        <CCol md={6} sm={12}>
          <CCard className="mb-4">
            <CCardHeader>By Wickets</CCardHeader>
            <CCardBody>
              <CCardBody>
                <CChartLine data={formattedWksData} />
              </CCardBody>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </>
  )
}

export default PlayerChart
